import * as React from "react";
import {UuiCircularChart} from "@aonunited/react";
import {ICircularChart} from "@aonunited/web-components";

export interface IDonutChartProps {
    completion: string | undefined
}

export const DonutChart : React.FunctionComponent<IDonutChartProps> = (props) => {
    const circularChartConfig = (value: string | undefined): ICircularChart => {
        const completionNumber = value ? Math.round(parseFloat(value.slice(0,5))): 0;
        return {
            arcThickness: 15,
            centerText: {
                primaryLabel: `${completionNumber.toString()}%`,
                primaryLabelPositionY: "10",
            },
            color: {
                palette: 0,
                contrast: 1
            },
            series: [
                {
                    name: "Data Completion",
                    data: [
                        {
                            name: "Completed",
                            y: completionNumber,
                            color: "#0084BB"
                        },
                        {
                            name: "Pending",
                            y: 100 - completionNumber,
                            color: "#DDE2E9"
                        }
                    ],
                },
            ],
            formatNumbers: false,
            radius: 100,
            type: 0
        };
    };

    return <div className="donut-chart__container" data-testid="donut-chart__container">
        <UuiCircularChart config={circularChartConfig(props.completion)}/>
        <div className="donut-chart__data-completion-text">Data completion</div>
    </div>;
};